import $ from 'jquery';

export default function () {
    if ($('#newExcavationAxisDialog') && $('#newExcavationAxisDialog').hasClass('show')) {
        $('#newExcavationAxisDialog').modal('hide');
    }

    $('[data-validation-ok="true"]', this).each(function () {
        $(this).closest(".modal").modal('hide');
        $(this).removeAttr('data-validation-ok');
    });
}